import {
  Mountain,
  MountainSnow,
  Library,
  Hammer,
  Umbrella,
  Factory,
  Wheat,
  TreeDeciduous,
  Cpu,
  Trees,
  Building2,
  Flower,
  CloudRain,
  Leaf,
  Shield,
  Sunrise,
  Snowflake,
  Landmark,
  TreePine,
  Feather,
  Layers,
  Coffee,
  TreePalm,
  Atom,
  Ship,
  BookOpen,
  Diamond,
  Telescope,
  BadgeCheck,
  Sparkles
} from "lucide-react";

const statesData = [
  { name: "Andhra Pradesh", icon: Layers },       // multi-region coastline
  { name: "Arunachal Pradesh", icon: Mountain },  // mountains + terrain
  { name: "Assam", icon: Coffee },                // tea/coffee culture
  { name: "Bihar", icon: BookOpen },              // Nalanda / education heritage
  { name: "Chhattisgarh", icon: Hammer },         // mining & steel
  { name: "Goa", icon: Umbrella },                // beaches
  { name: "Gujarat", icon: Diamond },             // diamond & industry
  { name: "Haryana", icon: Wheat },               // agriculture
  { name: "Himachal Pradesh", icon: MountainSnow }, // snowy mountains
  { name: "Jharkhand", icon: TreeDeciduous },     // forests + tribal
  { name: "Karnataka", icon: Cpu },               // IT hub
  { name: "Kerala", icon: TreePalm },             // coconut & palm
  { name: "Madhya Pradesh", icon: Trees },        // wildlife + forests
  { name: "Maharashtra", icon: Building2 },       // Mumbai skyline
  { name: "Manipur", icon: Flower },              // iconic flowers
  { name: "Meghalaya", icon: CloudRain },         // rainfall state
  { name: "Mizoram", icon: Leaf },                // greenery
  { name: "Nagaland", icon: Shield },             // warrior shield culture
  { name: "Odisha", icon: Landmark },             // Jagannath temple
  { name: "Punjab", icon: BadgeCheck },           // bravery/military history
  { name: "Rajasthan", icon: Sunrise },           // desert sunrise
  { name: "Sikkim", icon: Snowflake },            // snowy Himalayan state
  { name: "Tamil Nadu", icon: Telescope },        // astronomy & science hub
  { name: "Telangana", icon: Atom },              // tech startups
  { name: "Tripura", icon: TreePine },            // forests + terrain
  { name: "Uttar Pradesh", icon: Landmark },      // temples (different cultural meaning)
  { name: "Uttarakhand", icon: Sparkles },        // spiritual tourism
  { name: "West Bengal", icon: Feather },         // literature & arts
];

export default statesData;
